// extracted by mini-css-extract-plugin
module.exports = {"btnSelect":"SelectBtn_btnSelect__1e_U8"};